import { $api } from '../api'

export type AdminPushSubscriptionPayload = {
  endpoint: string
  p256dh: string
  auth: string
  preferredPizzeriaId?: number | null
  userAgent?: string | null
}

/**
 * HTTP-клиент для Web Push подписок админки.
 */
export default class AdminPushHttpService {
  /**
   * Публичный VAPID ключ.
   */
  static async getVapidPublicKey(): Promise<{ data: { publicKey: string } }> {
    return $api.get('/admin-push/vapid-public-key')
  }

  /**
   * Upsert подписки устройства.
   * @param data — endpoint, keys, preferred фильтр
   */
  static async upsertSubscription(
    data: AdminPushSubscriptionPayload
  ): Promise<{ data: unknown }> {
    return $api.post('/admin-push/subscriptions', data)
  }

  /**
   * Обновляет preferred-фильтр на всех устройствах админа.
   * @param preferredPizzeriaId — null = все в scope
   */
  static async patchPreference(
    preferredPizzeriaId: number | null
  ): Promise<{ data: { ok: true } }> {
    return $api.patch('/admin-push/subscriptions/preference', {
      preferredPizzeriaId,
    })
  }

  /**
   * Удаляет подписку по endpoint.
   * @param endpoint — URL подписки
   */
  static async deleteSubscription(
    endpoint: string
  ): Promise<{ data: { ok: true } }> {
    return $api.delete('/admin-push/subscriptions', { data: { endpoint } })
  }
}
